// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"89":"50e814e0","162":"3d66416b","187":"b1bb4b62","232":"8fa68ad1","519":"d545cea2","643":"89591b36","843":"9d99bbaa","921":"0112e792"}[chunkId] + ".chunk.css";
};